import { useCallback, useState } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import { Listable } from 'listable'
import { Dialog } from 'frame/components'
import Grid from '@mui/material/Grid'

import Row from '../list/row'
import Filters from '../filters'

import { createRowSelector } from 'utils'
import { actions, config } from '../../module'

/* -----------------------------
   LIST + MODAL (NORMAL WAY)
------------------------------ */

const List = ({ account, model }) => {
  const [selectedId, setSelectedId] = useState(null)

  const onClose = () => setSelectedId(null)

  const renderItem = useCallback(
    (item, index, itemProps) => {
      const onView = () => {
        setSelectedId(item.agreementNumber)
      }

      const onSafeRowClick = createRowSelector(onView)

      return (
        <Row
          key={index}
          account={account}
          item={item}
          {...itemProps}
          onView={onView}
          onClick={onSafeRowClick}/>
      )
    },
    [account]
  )

  const { ids, filters, ...rest } = model

  return (
    <>
      <Listable
        actions={actions}
        config={config}
        filters={Filters}
        model={rest}
        renderItem={renderItem}/>

      {/* NORMAL MODAL */}
      <Dialog
        open={Boolean(selectedId)}
        autoSize
        size="md"
        title={selectedId ? `Exception - ${selectedId}` : ''}
        onClose={onClose}>
        <Grid container>
          <Grid item xs={12}>
            {/* <Form incidentId={selectedId} onClose={onClose} /> */}
          </Grid>
        </Grid>
      </Dialog>
    </>
  )
}

List.propTypes = {
  account: PropTypes.string,
  model: PropTypes.object.isRequired,
}

const mapStateToProps = ({ reportExceptions, settings }) => ({
  account: settings?.account,
  model: reportExceptions,
})

export default connect(mapStateToProps)(List)
